"use client";
import React, { useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { faker } from "@faker-js/faker";
import moment from "moment";

export const getFilteredData = (data, searchText) => {
  return !searchText
    ? data
    : data?.filter((item) =>
        Object?.values(item)?.some((value) =>
          value?.toString()?.toLowerCase().includes(searchText?.toLowerCase())
        )
      );
};

export const success = (msg) =>
  toast.success(msg, {
    hideProgressBar: true,
    autoClose: 1500,
    position: "top-right",
  });

export const error = (msg) =>
  toast.error(msg, {
    hideProgressBar: true,
    autoClose: 1500,
    position: "top-right",
  });
export const info = (msg) =>
  toast.info(msg, {
    hideProgressBar: true,
    autoClose: 1500,
    position: "top-right",
  });

export const errorToast = (msg) =>
  toast.error(msg, {
    hideProgressBar: true,
    autoClose: 1500,
    position: "top-right",
  });

export const warning = (msg) =>
  toast.warning(msg, {
    hideProgressBar: true,
    autoClose: 1500,
    position: "top-right",
  });
// Date Picker Custom input
export const CustomInput = ({ value, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className="custom-date-input"
    // style={{ background: "transparent", border: "none", cursor: "pointer" }}
  >
    {/* <img src={"/images/date.svg"} alt="date-icon" loading="lazy" /> */}
  </button>
);

export const formatTime = (time) => {
  return moment(time).format("LT");
};

export const getTime = (timestamp) => {
  if (!moment(timestamp).isValid()) return "";
  return moment(timestamp).fromNow();
};

export const formatDate = (date) => {
  return moment(date).format("yyyy-MM-DD");
};

export const formatDateMonth = (date) => {
  return moment(date).format("ll");
};

export const TruncateText = ({ text, wordLimit, className }) => {
  const [isTruncated, setIsTruncated] = useState(true);
  const wordsArray = text?.split(" ");

  const handleShow = () => {
    setIsTruncated(!isTruncated); // Toggles between showing and truncating the text
  };

  if (wordsArray?.length > wordLimit) {
    return (
      <div className={className}>
        {isTruncated
          ? wordsArray.slice(0, wordLimit).join(" ") // Show truncated version
          : wordsArray.join(" ")}{" "}
        <span className="ms-2 cursor" onClick={handleShow}>
          {isTruncated ? "...View All" : " Show Less"}
        </span>
      </div>
    );
  }

  return <div>{text}</div>; // If the text length is within the limit, show full text
};

// export const ProtectedRoute = (NextResponse) => {
//   const loggedin = useSelector((state) => state.loggedin.value);

//   if (!loggedin) {
//     return NextResponse.redirect(new URL("/", request.url));
//   }
//   return NextResponse.next();
// };

// export const ProtectedRoute = (request) => {
//   const loggedin = request.cookies.get("loggedin"); // Adjust this line based on how you track login status
//   console.log(
//     loggedin,
//     "anasssssssssssssssssssssssss",
//     loggedin.value == "false"
//   );

//   if (loggedin.value == "false") {
//     return NextResponse.redirect(new URL("/", request.url));
//   }
//   return NextResponse.next();
// };

export function createRandomChat() {
  return {
    id: faker.string.uuid(), // Generates a unique ID
    sender: faker.person.fullName(), // Generates a full name for the user
    image: faker.image.avatar(), // Generates a random avatar image URL
    message: faker.lorem.words(10), // Generates a text with 10 random words
    time: "12:pm", // Generates a recent time in short format
    type: faker.helpers.arrayElement(["received", "sent"]),
  };
}

export const StringSplice = (text, length) => {
  if (!text) {
    return "";
  }

  if (!length) {
    return "Please mention length !";
  }

  return text?.length > length ? text.slice(0, length) + "..." : text;
};

export function timeAgo(timestamp) {
  const now = new Date();
  const messageTime = new Date(timestamp);

  const diff = now - messageTime;

  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  const months = Math.floor(days / 30);
  const years = Math.floor(days / 365);

  if (years > 0) {
    return years === 1 ? `${years} year ago` : `${years} years ago`;
  } else if (months > 0) {
    return months === 1 ? `${months} month ago` : `${months} months ago`;
  } else if (days > 0) {
    return days === 1 ? `${days} day ago` : `${days} days ago`;
  } else if (hours > 0) {
    return hours === 1 ? `${hours} hour ago` : `${hours} hours ago`;
  } else if (minutes > 0) {
    return minutes === 1 ? `${minutes} minute ago` : `${minutes} minutes ago`;
  } else {
    // return seconds === 1 ? `${seconds} second ago` : `${seconds} seconds ago`;
    return seconds === 1 ? `just now` : `just now`;
  }
}
